import React from 'react';
import PropTypes from 'prop-types';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import ListingType from '@domain-group/fe-allhomes-library/lib/enums/listing-type';
import ListingCategory from '@domain-group/fe-allhomes-library/lib/enums/listing-category';
import ArrowLeftIcon from '@domain-group/fe-co-icon/lib/js/chevron-left';
import ArrowRightIcon from '@domain-group/fe-co-icon/lib/js/chevron-right';
import * as styles from './allhomes-listing-recently-sold-link.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getLabel = (listingType, isMobile) => "View ".concat(isMobile ? '' : 'recently ').concat(listingType.pastParticiple);
var getSoldPageLabel = listingType => "View ".concat((listingType && listingType.category) === ListingCategory.RENT ? 'for rent' : 'for sale');
var RecentlySoldLink = _ref => {
  var listingType = _ref.listingType,
    isSoldPage = _ref.isSoldPage,
    isMobile = _ref.isMobile,
    linkUrl = _ref.linkUrl,
    onClick = _ref.onClick;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var handleClick = event => {
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
  };
  return ___EmotionJSX("a", {
    href: getAbsoluteUrl(linkUrl),
    css: styles.linkButton,
    onClick: handleClick
  }, isMobile && isSoldPage && ___EmotionJSX(ArrowLeftIcon, {
    size: "small",
    css: styles.linkButtonIcon
  }), (isSoldPage ? getSoldPageLabel : getLabel)(ListingType[listingType], isMobile), isMobile && !isSoldPage && ___EmotionJSX(ArrowRightIcon, {
    size: "small",
    css: styles.linkButtonIcon
  }));
};
RecentlySoldLink.propTypes = {
  listingType: PropTypes.string.isRequired,
  isSoldPage: PropTypes.bool,
  isMobile: PropTypes.bool,
  linkUrl: PropTypes.string,
  onClick: PropTypes.func
};
RecentlySoldLink.defaultProps = {
  isMobile: false,
  isSoldPage: false,
  linkUrl: '',
  onClick: null
};
export default RecentlySoldLink;